import moment from 'moment';

export const subtractNDays = (n: number) => {
  const date = moment(new Date()).subtract(n, 'days').toDate();
  return date;
};
